import { auth, custom } from '@/service';
import config from '@/config';
import * as _ from 'lodash'
import Language from './language'

import { SetLang } from '@/service/i18n'


const i18n_data = {
  confirm : {
    EN : `now the password change cycle reached, now change it?`,
    KO : `비밀번호 변경주기에 도달했어요. 지금 변경할까요?`
  },
  username : {
    EN : `Please enter your username (email).`,
    KO : `이메일을 입력하세요 (이메일)`
  },
  password : {
    EN : `Please enter your password.`,
    KO : `비밀번호를 입력하세요.`
  },
  signing : {
    EN : `Signing in....`,
    KO : `로그인 중....`
  },
  otp : {
    EN : `please input OTP`,
    KO : `OTP 를 입력하세요.`
  }
}

export default {
  components: {
    Language
  },
  computed: {
    i18n_data() {
      return i18n_data;
    }
  },
  data: () => ({
    check_preflight : false,
    require_otp : false,
    save_username: false,
    is_require_change_password : false,
    m: { username: '', password: '', otp : '' }, lock: false,
    custom : custom.default,
  }),
  methods: {
    reset() {
      this.$router.push({ name: 'auth_reset' });
    },
    preflight() {
      // preflight is return password cycle reached or not
      return auth.preflight(this.m.username, this.m.password);
    },
    async login() {
      let lang = SetLang(localStorage['UWSS_MANAGER_LANG'] || 'EN');

      if(_.isEmpty(this.m.username)) { return this.$toastr.e(this.i18n_data['username'][lang]); }
      if(_.isEmpty(this.m.password)) { return this.$toastr.e(this.i18n_data['password'][lang]); }
      if(this.lock) { return this.$toastr.i(this.i18n_data['signing'][lang]); }
      try {
        if(!this.check_preflight) {
          this.require_otp = await this.preflight();
          this.check_preflight = true;
        }
        if(this.require_otp && !this.m.otp) { return this.$toastr.i(this.i18n_data['otp'][lang], 'require') }
        // 패스워드 변경할지 안할지 확인, 변경할 경우 리다이젝션 변경
      } catch (e) { console.log(e); return this.$toastr.w(e.data ? e.data.message : e.statusText); }

      this.lock = true;
      try {
        let rs = await auth.login(this.m.username, this.m.password, this.m.otp);
        if(rs) {
          // check password cycle
          let ts = new Date().getTime();
          this.is_require_change_password = await auth.checkPasswordCycle({ ts : ts });
          // this.$route.query.redirect = this.is_require_change_password && confirm("now the password change cycle reached, now change it ?")
          this.$route.query.redirect = this.is_require_change_password && confirm(this.i18n_data['confirm'][lang])
          ? "/management/profile/edit"
          : (auth.profile.permissions.toLowerCase() == 'sales' ? '/dashboard_sales' : '/dashboard')
        }

        console.log(this.$route.query.redirect, 'this.$route.query.redirect', auth.profile.permissions.toLowerCase() == 'sales', auth.profile.permissions.toLowerCase(), 'sales')
        if(this.save_username) { window.localStorage.setItem('username', this.m.username); } else { window.localStorage.removeItem('username'); }
        this.$router.replace(this.$route.query.redirect || (auth.profile.permissions.toLowerCase() == 'sales' ? '/dashboard_sales' : '/dashboard')); // 대시보드 경로로 변경 필요함
      } catch(e) { console.log(e); this.$toastr.w(e.data ? e.data.message : e.statusText); }
      this.lock = false;
    },
  },
  created() { console.log('[vue] login', 'created'); },
  destroyed() { console.log('[vue] login', 'destroyed'); },
  mounted() {
    this.custom = custom.setting()
    console.log(this.custom)
    console.log('[vue] login', 'mounted');
    if(auth.loggedIn()) { this.$router.replace(auth.profile.permissions.toLowerCase() == 'sales' ? '/dashboard_sales' : '/dashboard');  }// 대시보드 경로로 변경 필요함
    if(window.localStorage.getItem('username')) { console.log('load', 'username'); this.save_username = true; this.m.username = window.localStorage.getItem('username'); }
    this.custom.version = config.version
  }
}